export default {
  path: '/usuarios/:id',
  component: () => import('@/components/dialog/User')
}
